import useShowBusinessModal from "@/domains/business/hooks/useShowBusinessModal";
import BusinessInfoModalContainer from "@/domains/business/containers/modals/BusinessInfoModalContainer";
import BusinessSaleModalContainer from "@/domains/business/containers/modals/BusinessSaleModalContainer";

export default function BusinessModalsContainer() {
  const { isLoading, info, exit, buyBusiness, isBuying } = useShowBusinessModal();
  const isInfoModal = info && info?.owner?.characterId;
  const isSaleModal = info && !info?.owner?.characterId;

  return (
    <>
      {isInfoModal && <BusinessInfoModalContainer isLoading={isLoading} info={info} exit={exit} />}
      {isSaleModal && (
        <BusinessSaleModalContainer
          isLoading={isLoading}
          info={info}
          exit={exit}
          buyBusiness={buyBusiness}
          isBuying={isBuying}
        />
      )}
    </>
  );
}
